import { useState, useCallback, useEffect, useRef } from "react"
import { useLocation } from "react-router"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
// import Div100vh from "react-div-100vh"
import {
  LinkGroup,
  LinkItem,
  OpenToggle,
  CloseToggle,
  NavMenuHolder,
  ButtonHolder
} from "./NavigationMenu.style"
import { motion } from "framer-motion"
import { io } from "socket.io-client"
import Pusher from "pusher-js"
import homeIcon from "./home.svg"
import lightsIcon from "./lights.svg"
import refreshIcon from "./refresh.svg"
import zones from "../LightsBroadcaster/zones"
import { useStore } from "../ApartmentFinder/State/Store"

// import { useStore } from "components/ApartmentFinder/State/Store"
const url = process.env.REACT_APP_MARKETING_SUITE

const ContainerVariants = {
  show: {
    transition: {
      staggerChildren: 0.09,
      delayChildren: 0.3
    }
  },
  hidden: { staggerChildren: 0.05, staggerDirection: -1 }
}

const ItemVariants = {
  show: {
    y: 0,
    opacity: 1,
    transition: {
      y: { stiffness: 1000, velocity: -100 }
    }
  },
  hidden: {
    y: 50,
    opacity: 0,
    transition: {
      y: { stiffness: 1000 }
    }
  }
}

const NavigationMenu = ({ routes }) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  const setApartmentFinderActive = useStore(
    state => state.setApartmentFinderActive
  )
  const setCurrentCameraPositionID = useStore(
    state => state.setCurrentCameraPositionID
  )
  const handleToggleMenu = useCallback(() => {
    setIsOpen(open => !open)
  }, [])

  const { pathname } = useLocation()
  const { path: currentLocation } =
    routes.find(({ path }) => pathname.startsWith(path)) || routes[0]

  const channel = useRef()
  const socket = useRef()

  useEffect(() => {
    if (url && role) {
      socket.current = io(url)
      socket.current.on("reload", data => {
        window.location.href = "/"
      })
    }
  }, [])

  useEffect(() => {
    if (role === "sender") {
      const pusher = new Pusher("3cf74e9446774f909693", {
        cluster: "eu",
        authEndpoint: "https://llco-leyton-dev.ew.r.appspot.com/pusher/auth"
      })
      channel.current = pusher.subscribe("private-llco-leyton-dev")
    }
  }, [])

  const enterApartmentFinderClick = () => {
    setApartmentFinderActive(true)
    setCurrentCameraPositionID("site")
  }

  const lightsOff = () => {
    channel.current.trigger("client-zones-off", { zones })
  }

  const role = process.env.REACT_APP_ROLE

  return (
    <NavMenuHolder isopen={isOpen}>
      <ButtonHolder role={role}>
        <Link to="/" onClick={() => setIsOpen(false)}>
          <img src={homeIcon} alt="home" />
        </Link>
        <Link to="/" onClick={() => setIsOpen(false)}>
          <img
            src={refreshIcon}
            alt="refresh"
            onClick={() => {
              socket.current.emit("reload", true)
              setTimeout(() => {
                window.location.reload()
              }, 500)
            }}
            style={{ cursor: "pointer", display: "block", width: "100%" }}
          />
        </Link>
        {role === "sender" && (
          <img
            src={lightsIcon}
            alt="lights-off"
            onClick={lightsOff}
            style={{ cursor: "pointer", display: "block", width: "100%" }}
          />
        )}
      </ButtonHolder>
      {role !== "recipient" && <OpenToggle onClick={handleToggleMenu} />}
      <LinkGroup>
        <motion.ul
          variants={ContainerVariants}
          initial="hidden"
          animate={isOpen ? "show" : "hidden"}
        >
          {routes.map(({ path }, index) => (
            <motion.li
              onClick={
                index === 2
                  ? () => enterApartmentFinderClick()
                  : () => setApartmentFinderActive(false)
              }
              // onClick={() => console.log(index)}
              key={index}
              variants={ItemVariants}
              whileHover={{ scale: 1.01 }}
              // x: "5%",
              whileTap={{ scale: 1.01 }}
              style={{ listStyleType: "none" }}
            >
              <LinkItem key={path}>
                <Link onClick={handleToggleMenu} to={isOpen ? path : "#"}>
                  {isOpen
                    ? t(`navigation.${path}`)
                    : index === 0
                    ? t(`navigation.${currentLocation}`)
                    : t(`navigation.${path}`)}
                </Link>
              </LinkItem>
            </motion.li>
          ))}
        </motion.ul>
        <CloseToggle onClick={handleToggleMenu} />
      </LinkGroup>
    </NavMenuHolder>
  )
}

export default NavigationMenu
